import axios from "axios";
import moment from "moment";
import bus from "@/EventBus";

export default {
  namespaced: true,
  state: {
    temporadas: [],
    temporada: {},
  },
  mutations: {
    llenarTemporadas(state, data) {
      state.temporadas = [];
      state.temporadas = data;
    },
    llenarTemporada(state, data) {
      state.temporada = {};
      state.temporada = data;
    },
  },
  actions: {
    getTemporadas: async function({ commit }, token) {
      let header = { Token: token };
      let configuracion = { headers: header };
      let data = null;

      await axios
        .get("temporada/", configuracion)
        .then(function(response) {
          data = response.data;
          commit("llenarTemporadas", data);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getTemporada: async function({ commit, dispatch }, data) {
      debugger;
      let header = { Token: data.token };
      let configuracion = { headers: header };
      let d = null;
      debugger;
      await axios
        .get(`temporada/query?id=${data.id}`, configuracion)
        .then(function(response) {
          commit("llenarTemporada", response.data);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    saveTemporada: async function({ dispatch }, data) {
      let header = { Token: data.token };
      let configuracion = { headers: header };
      await axios
        .post(
          "temporada/",
          {
            usuario: data.usuario,
            nombre: data.obj.nombre,
            fecha_inicio: data.obj.fecha_inicio,
            fecha_fin: data.obj.fecha_fin,
          },
          configuracion
        )
        .then(function(res) {
          dispatch("getTemporadas", data.token);
          swal({
            title: "Buen trabajo!",
            text: `Temporada ${res.data.result.nombre} agregada correctamente`,
            icon: "success",
          });
        })
        .catch(function(error) {
          swal({
            title: "Lo sentimos!",
            text: `Ha ocurrido un error de tipo ${error}`,
            icon: "error",
          });
        });
    },
    sendEmail: async function({ commit }, data) {
      await axios
        .post("email/confirm", {
          dataReserva: data.res,
        })
        .then(function() {
          swal({
            title: "Buen trabajo!",
            text: `Email enviado correctamente`,
            icon: "success",
          });
        })
        .catch(function(error) {
          swal({
            title: "Lo sentimos!",
            text: `Ha ocurrido un error de tipo ${error}. Informe al departamento de desarrollo`,
            icon: "error",
          });
        });
      commit();
    },
    updateTemporada: async function({ dispatch }, data) {
      let header = { Token: data.token };
      let configuracion = { headers: header };
      await axios
        .put(
          `temporada?id=${data.obj.id}`,
          {
            usuario: data.usuario,
            nombre: data.obj.nombre,
            fecha_inicio: data.obj.fecha_inicio,
            fecha_fin: data.obj.fecha_fin,
          },
          configuracion
        )
        .then(function(res) {
          dispatch("getTemporadas", data.token);
          swal({
            title: "Buen trabajo!",
            text: `Temporada ${res.data.result.nombre} actualizada correctamente`,
            icon: "success",
          });
        })
        .catch(function(error) {
          swal({
            title: "Lo sentimos!",
            text: `Ha ocurrido un error de tipo ${error}`,
            icon: "error",
          });
        });
    },
    activateTemporada: async function({ dispatch }, data) {
      let header = { Token: data.token };
      let configuracion = { headers: header };
      //debugger
      await axios
        .put(`temporada/`, { id: data.id }, configuracion)
        .then(function() {
          dispatch("getTemporadas", data.token);
          swal({
            title: "Buen trabajo!",
            text: `Reserva activada correctamente`,
            icon: "success",
          });
        })
        .catch(function(error) {
          swal({
            title: "Lo sentimos!",
            text: `Ha ocurrido un error de tipo ${error}`,
            icon: "error",
          });
        });
    },
    deactivateTemporada: async function({ dispatch }, data) {
      let header = { Token: data.token };
      let configuracion = { headers: header };
      await axios
        .put("temporada/", { id: data.id }, configuracion)
        .then(function() {
          dispatch("getTemporadas", data.token);
          swal({
            title: "Buen trabajo!",
            text: `Reserva desactivada correctamente`,
            icon: "success",
          });
        })
        .catch(function(error) {
          swal({
            title: "Lo sentimos!",
            text: `Ha ocurrido un error de tipo ${error}`,
            icon: "error",
          });
        });
    },
    deleteTemporada: async function({ dispatch }, data) {
      let token = data.token;
      let header = { Token: token };
      let configuracion = { headers: header };
      await axios
        .delete(`temporada?id=${data.id}`, configuracion)
        .then(function() {
          // debugger
          dispatch("getTemporadas", data.token);
          swal({
            title: "Buen trabajo!",
            text: `Temporada eliminada correctamente`,
            icon: "success",
          });
        })
        .catch(function(error) {
          swal({
            title: "Lo sentimos!",
            text: `Ha ocurrido un error de tipo ${error}`,
            icon: "error",
          });
        });
    },
  },
};
